let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i9Kzu")).then(() => parcelRequire('9BdA2'));